import { createSelector } from 'reselect';
import { getLoggedUser } from '@domain/logged-user/logged-user.state';
import { createReducer, INITIAL_STATE } from '../../../shared/redux';

export const USER_PROFILE_ATTRIBUTES_LOADED = '@auth/USER_PROFILE_ATTRIBUTES_LOADED';

export const UPDATE_PASSWORD_MODAL_CHANGED = '@auth/UPDATE_PASSWORD_MODAL_CHANGED';

export const UPDATE_USER_PROFILE_SUBMITTED = '@auth/UPDATE_USER_PROFILE_SUBMITTED';
export const UPDATE_USER_PROFILE_ACCEPTED = '@auth/UPDATE_USER_PROFILE_ACCEPTED';
export const UPDATE_USER_PROFILE_REJECTED = '@auth/UPDATE_USER_PROFILE_REJECTED';

export const UPDATE_PASSWORD_SUBMITTED = '@auth/UPDATE_PASSWORD_SUBMITTED';
export const UPDATE_PASSWORD_ACCEPTED = '@auth/UPDATE_PASSWORD_ACCEPTED';
export const UPDATE_PASSWORD_REJECTED = '@auth/UPDATE_PASSWORD_REJECTED';

export const isUpdateUserProfileModalOpen = state => state.auth.updateUserProfile.isModalOpen;
export const isUpdateUserProfileLoading = state => state.auth.updateUserProfile.loading;
export const isUpdateUserProfileError = state => state.auth.updateUserProfile.error;

// TODO: https://github.com/paretogroup/quantic-spa/issues/528
export const getUserProfileAttributes = createSelector(getLoggedUser, loggedUser => ({
    name: loggedUser.full_name,
    email: loggedUser.email,
    picture: loggedUser.user_img_path,
    username: loggedUser.username,
}));

export const loadUserProfileAttributes = ({
    username, name, email, picture,
}) => ({
    type: USER_PROFILE_ATTRIBUTES_LOADED,
    payload: {
        username,
        name,
        email,
        picture,
    },
});

export const changeUpdatePasswordModalState = open => ({
    type: UPDATE_PASSWORD_MODAL_CHANGED,
    payload: { open },
});

export const openUpdatePasswordModal = () => changeUpdatePasswordModalState(true);
export const closeUpdatePasswordModal = () => changeUpdatePasswordModalState(false);

export const submitUpdateUserProfile = ({ name, picture }) => ({
    type: UPDATE_USER_PROFILE_SUBMITTED,
    payload: {
        name,
        picture,
    },
});

export const acceptUpdateUserProfile = () => ({
    type: UPDATE_USER_PROFILE_ACCEPTED,
    payload: {},
});

export const rejectUpdateUserProfile = ({ error }) => ({
    type: UPDATE_USER_PROFILE_REJECTED,
    payload: { error },
});

export const submitUpdatePassword = ({ currentPassword, newPassword, confirmPassword }) => ({
    type: UPDATE_PASSWORD_SUBMITTED,
    payload: {
        currentPassword,
        newPassword,
        confirmPassword,
    },
});

export const acceptUpdatePassword = () => ({
    type: UPDATE_PASSWORD_ACCEPTED,
    payload: {},
});

export const rejectUpdatePassword = ({ error }) => ({
    type: UPDATE_PASSWORD_REJECTED,
    payload: { error },
});

const updateError = (state, action) => ({ ...state, loading: false, error: action.payload.error });
const updateFlags = (loading, error = null) => state => ({ ...state, loading, error });

export const updateUserProfileReducer = createReducer({
    [INITIAL_STATE]: {
        isModalOpen: false,
        error: null,
        loading: false,
    },

    [USER_PROFILE_ATTRIBUTES_LOADED]: (state, action) => ({
        ...state,
        userAttributes: action.payload,
    }),

    [UPDATE_PASSWORD_MODAL_CHANGED]: (state, action) => ({
        ...state,
        isModalOpen: action.payload.open,
    }),

    [UPDATE_USER_PROFILE_SUBMITTED]: updateFlags(true),
    [UPDATE_USER_PROFILE_ACCEPTED]: updateFlags(false),
    [UPDATE_USER_PROFILE_REJECTED]: updateError,

    [UPDATE_PASSWORD_SUBMITTED]: updateFlags(true),
    [UPDATE_PASSWORD_ACCEPTED]: updateFlags(false),
    [UPDATE_PASSWORD_REJECTED]: updateError,
});
